import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'
import { type ApiQueryResult } from '~/utils/types'

export const useCourseServersQuery = (courseId, refetch: boolean = false): ApiQueryResult =>
  useQuery({
    queryKey: ['courses', courseId, 'servers'],
    queryFn: async () => {
      const { data } = await adminApi.getCourseServers(courseId)
      return data.data
    },
    initialData: [],
    refetchInterval: (refetch ? 2000 : false)
  })

export const useAppstreamsQuery = (courseId): ApiQueryResult => {
  return useQuery({
    queryKey: ['courses', courseId, 'appstreams'],
    queryFn: async () => {
      const { data } = await adminApi.getAppstreams(courseId)
      return data.data
    },
    initialData: () => []
  })
}
